import { CheckCircle2, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SUPPORT_EMAIL } from './support'

interface CheckoutRecoveryPanelProps {
  checkoutId: string
  // True once confirmation polling exhausted its attempts: the payment
  // completed but Cortado has not observed the subscription yet.
  exhausted: boolean
  // How many times the user has already clicked "Retry confirmation" for
  // this checkout, so the copy can stop implying a plain retry will help
  // once one has already failed.
  retryCount: number
  onRetry: () => void
  onStartOver: () => void
}

export function CheckoutRecoveryPanel({
  checkoutId,
  exhausted,
  retryCount,
  onRetry,
  onStartOver,
}: CheckoutRecoveryPanelProps) {
  return (
    <div role="status" className="rounded-xl border bg-muted/30 p-6 text-center">
      {exhausted ? (
        <CheckCircle2 className="mx-auto h-6 w-6 text-status-success-fg" />
      ) : (
        <Loader2 className="mx-auto h-6 w-6 animate-spin" />
      )}
      <h3 className="mt-3 font-semibold">Confirming subscription</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        {exhausted
          ? retryCount > 0
            ? "Still not confirmed after retrying. This may need a closer look — contact support if it doesn't resolve soon."
            : 'Checkout completed, but confirmation is still pending. You can safely retry.'
          : 'Waiting for Cortado to confirm the subscription.'}
      </p>
      {exhausted && (
        <div className="mt-4 flex flex-wrap justify-center gap-2">
          <Button onClick={onRetry}>Retry confirmation</Button>
          <Button variant="outline" onClick={onStartOver}>
            Start over
          </Button>
          <Button variant="outline" asChild>
            <a href={`mailto:${SUPPORT_EMAIL}?subject=Checkout%20confirmation%20${checkoutId}`}>
              Contact support
            </a>
          </Button>
        </div>
      )}
    </div>
  )
}
